/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// Soft UI Dashboard PRO React context
import { useSoftUIController, setSportsNumbers } from "context";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Fab from "@mui/material/Fab";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftProgress from "components/SoftProgress";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";
import TemplatesApplier from "views/TemplatesApplier";
import Sidenav from "./components/Sidenav";

// Soft UI Dashboard PRO React page layout routes

// sweetalert2 components
import Swal from "sweetalert2";

// Wizard application components
import FixturesTable from "views/fixtures-table";

import TableContainer from "@mui/material/TableContainer";
import { Button } from "@mui/material";

import { getUserData, getAuthorizationHeader } from "Utils/helpers";
import { getData } from "Utils/server";

let timeleft = 30000;
let sportNumbersTimeout = null;
let waitForSwal = null;

let lastTypeSelected = null;
let lastSportSelected = null;

function Sportsbook({ sportId, filterTemplateId }) {
  const href = window.location.href;
  const hrefParts = href.split("monitoring/");
  const eventType = hrefParts.length > 1 ? hrefParts[1].split("/")[0].split("-")[0] : "inplay";
  const sport = sportId || parseInt(href.split(eventType + "/")[1] || 1);
  const filterId = filterTemplateId || parseInt(href.split("#")[1]);

  let initializing = false;

  const [filtersData, setFiltersData] = useState(null);
  const [openTemplateApplier, setOpenTemplateApplier] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(false);
  const [selectedTemplateData, setSelectedTemplateData] = useState(false);
  const [autoRefresh, setAutoRefresh] = useState(false);
  const [refreshPressed, setRefreshPressed] = useState(false);
  const [refresh, setRefresh] = useState(1);
  const [floatButton, setFloatButton] = useState(false);
  const [refreshPercentage, setRefreshPersentage] = useState(0);
  const [timeTick, setTimeTick] = useState(0);
  const [sidenavCollapse, setSidenavCollapse] = useState(false);

  const [sportSelected, setSportSelected] = useState(sportId ? sportId : 0);
  const [typeSelected, setTypeSelected] = useState(null);

  const [controller, dispatch] = useSoftUIController();
  const {
    miniSidenav,
    fixedNavbar,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    permissions,
    platform,
    activeTemplate,
    sports_numbers,
    sports,
    providers,
    marketGroups,
  } = controller;

  let timeLeftTimeout;

  
  /**
   *
   */
  function initData() {
    if (selectedTemplateData) {
      setFiltersData(selectedTemplateData);
    }
  }

  const getSportsNumbers = async (force, permissions) => {
    if (!force) {
      if (sportNumbersTimeout) return;
      sportNumbersTimeout = setTimeout(() => {
        initializing = false;
        clearTimeout(sportNumbersTimeout);
        sportNumbersTimeout = null;
        getSportsNumbers();
      }, 60000);
    } else {
      initializing = false;
      clearTimeout(sportNumbersTimeout);
      sportNumbersTimeout = null;
    }

    if (force) {
      sportNumbersTimeout = setTimeout(() => {
        initializing = false;
        clearTimeout(sportNumbersTimeout);
        sportNumbersTimeout = null;
        getSportsNumbers();
      }, 60000);
    }

    if (initializing) return;
    let userData = getUserData();
    if (!userData) return;
    initializing = true;
    let platformId = userData.defaultPlatform
      ? userData.defaultPlatform.value
      : userData.platforms.length > 0
      ? userData.platforms[0].id
      : null;
    let response = null;
    if (platformId) {
      let getOddsEndpoint = `/api/v1/keys/${platformId}/sportscounters`;
      response = await getData(getOddsEndpoint, {
        Authorization: getAuthorizationHeader(),
      });
    }

    if (response != null) {
      let sports = response.data;
      sports.sort((a, b) => {
        return a.id - b.id;
      });

      setSportsNumbers(dispatch, response.data);
      if (response.data.length > 1) {
        if (!lastTypeSelected) {
          setTypeSelected("inplay");
          setSportSelected(response.data[1].id);
          lastTypeSelected = "inplay";
          lastSportSelected = response.data[1].id;
        }
        if (!response.data.find((s) => s.id == lastSportSelected)) {
          lastSportSelected = response.data[1].id;
          setSportSelected(response.data[1].id);
        }
        if (lastTypeSelected) {
          setTypeSelected(lastTypeSelected);
        }
        if (lastSportSelected) {
          setSportSelected(lastSportSelected);
        }
      } else {
      }

      if (waitForSwal) {
        waitForSwal.close();
        waitForSwal = null;
      }
    } else {
      if (waitForSwal) {
        waitForSwal.close();
        waitForSwal = null;
      }
    }
  };

  function handleDataConfigurator(selectedConfig, method) {
    if (selectedConfig) {
      setOpenTemplateApplier(false);
      setSelectedTemplate(selectedConfig.name);
      setSelectedTemplateData(selectedConfig);
      setFiltersData(selectedConfig);
    } else {
      setOpenTemplateApplier(false);
      setSelectedTemplate(false);
      setSelectedTemplateData(false);
      setFiltersData(null);
    }

    //setMiniSidenav(dispatch, false);

    if (method === "save") {
      //console.log("SAVE TEMPLATE in DB");
    }
  }

  function handleOpenConfigurator(e) {
    e.preventDefault();
    setOpenTemplateApplier(true);
  }

  function handleCloseConfigurator(e) {
    e.preventDefault();
    setOpenTemplateApplier(false);
  }

  function handleRefreshData(e) {
    e.preventDefault();
    let newDate = new Date().getTime();

    if (newDate - refresh > 30000) {
      setRefreshPressed(true);
      setRefresh(newDate);
      timeLeftTimeout = setInterval(() => {
        if (calculateTimeLeft() <= 0) {
          freeupRefresh();
          return;
        }
      }, 1000);
    }
  }

  function calculateTimeLeft() {
    let tm = timeleft - 1000;
    timeleft = tm;
    setTimeTick(tm / 1000);
    return tm;
  }

  function freeupRefresh() {
    clearTimeout(timeLeftTimeout);
    timeleft = 30000;
    setTimeTick(timeleft / 1000);
    setRefreshPressed(false);
  }

  async function scrollToTop(e) {
    e.preventDefault();
    location.href = `#topCompetitions`;

    location.href = `#topPage`;
  }

  function scrolling(e) {
    if (e.target.scrollTop > 50) {
      setFloatButton(true);
    } else {
      setFloatButton(false);
    }
  }

  // function handleAutoRefresh() {
  //   timeleft = 30000;
  //   setTimeTick(timeleft / 1000);
  // }

  function handleActions(data) {
    if (data == "resetTimer") {
      freeupRefresh();
    }
    if (data == "startTimer") {
      setTimeTick(-1 / 1000);
    }
  }

  const handleSideNavCollapse = (collapse) => {
    setSidenavCollapse(collapse);
  };

  const handleInformParent = (id, label, type) => {
    setSportSelected(id ? id : 0);
    lastSportSelected = id ? id : 0;
    if (type) {
      setTypeSelected(type);
      lastTypeSelected = type;
    }
  };

  const handlePlatformChange = () => {
    if (waitForSwal) return;
    waitForSwal = Swal.fire({
      title: "We proccess your request! ",
      html: "Wait for few seconds...",
      timerProgressBar: true,
      didOpen: async () => {
        Swal.showLoading();
      },
      willClose: () => {},
      allowOutsideClick: false,
    });
  };

  useEffect(() => {
    let cyrcle = 30000;
    // if (autoRefresh) cyrcle = 30000;
    if (timeleft) setRefreshPersentage(100 - (100 * timeleft) / cyrcle);
  }, [timeTick]);

  useEffect(() => {
    if (activeTemplate) getSportsNumbers(true);
  }, [activeTemplate]);

  useEffect(() => {
    handlePlatformChange();
  }, [platform]);

  useEffect(() => {
    return () => {
      if (timeLeftTimeout) clearTimeout(timeLeftTimeout);
      if (sportNumbersTimeout) {
        clearTimeout(sportNumbersTimeout);
        sportNumbersTimeout = null;
      }
    };
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <SoftBox my={3} sx={{ marginBottom: "0px" }}>
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          p={3}
          sx={{ paddingTop: "0px", paddingRight: "0px" }}
        >
          <SoftBox mt={0} className="settlement-page-holder">
            <Grid container spacing={3}>
              <Grid
                item
                xs={12}
                lg={sidenavCollapse ? 1 : 4}
                sx={{
                  width: sidenavCollapse ? "auto" : "calc(33% - 250px) !important",
                  // minWidth: "350px !important",
                  // width: "370px !important",
                  // maxWidth: "370px",
                }}
                className="secondary-menu-fixed-settlement"
              >
                <Sidenav
                  informParent={handleInformParent}
                  sportData={sports_numbers}
                  sidenavCollapse={handleSideNavCollapse}
                  eventTypeSelected={typeSelected}
                  parentSportSelected={sportSelected}
                />
              </Grid>
              <Grid
                item
                xs={12}
                lg={sidenavCollapse ? 11 : 8}
                sx={{
                  marginLeft: sidenavCollapse ? "120px !important" : "calc(33% - 150px) !important",
                  // width: "calc(100vw - 370px) !important",
                  // maxWidth: miniSidenav
                  //   ? fixedNavbar
                  //     ? "calc(100vw - 410px) !important"
                  //     : "calc(100vw - 520px) !important"
                  //   : "calc(100vw - 680px) !important",
                  // left: "360px",
                  // marginLeft: "0 !important",
                }}
                className="scrolling-main-page-settlement"
              >
                <SoftBox my={3}>
                  <Card>
                    <SoftBox>
                      <div id="topPage" style={{ opacity: "hidden" }}></div>
                      <Card style={{ boxShadow: "none" }}>
                        <SoftBox>
                          <SoftBox
                            display="flex"
                            justifyContent="space-between"
                            alignItems="flex-start"
                            p={3}
                          >
                            <SoftBox lineHeight={1}>
                              <SoftTypography variant="h5" fontWeight="medium">
                                {sports && sportSelected
                                  ? sports.find((item) => item.id == sportSelected)["name"]
                                  : ""}
                              </SoftTypography>
                              <SoftTypography variant="button" fontWeight="regular" color="text">
                                <span>List of Available </span>
                                <span style={{ fontWeight: "bold" }}>{typeSelected}</span>
                                <span> Fixtures.</span>
                              </SoftTypography>
                            </SoftBox>
                            <Stack spacing={1} direction="row">
                              <Tooltip
                                title={selectedTemplate ? "" : "Please Apply a Filter first"}
                                placement="left"
                              >
                                <Fab
                                  variant="extended"
                                  color="primary"
                                  aria-label={selectedTemplate}
                                  style={{ fontSize: "small", color: "#fff" }}
                                  className="float-templatename-show-btn"
                                  onClick={(e) => handleOpenConfigurator(e)}
                                >
                                  <Icon fontSize="small" fontWeight="100">
                                    view_in_ar_outlined_icon
                                  </Icon>
                                  <SoftTypography
                                    style={{
                                      fontSize: "medium",
                                      color: "#fff",
                                      paddingLeft: "5px",
                                    }}
                                  >
                                    {selectedTemplate ? selectedTemplate : "None Template Selected"}
                                  </SoftTypography>
                                </Fab>
                              </Tooltip>
                            </Stack>
                          </SoftBox>
                          <SoftBox lineHeight={1} display="flex" alignItems="first baseline" pl={3}>
                            <SoftBox style={{ width: "100%" }}></SoftBox>
                            <SoftBox
                              display="flex"
                              alignItems="first baseline"
                              className="refresh-switch-holder"
                            >
                              <SoftBox>
                                <SoftTypography
                                  variant="button"
                                  fontWeight="regular"
                                  style={{
                                    marginRight: "5px",
                                    color: "#67748e",
                                  }}
                                >
                                  Refresh:
                                </SoftTypography>
                              </SoftBox>
                              <SoftBox>
                                <Switch
                                  color="info"
                                  checked={autoRefresh}
                                  onChange={() => setAutoRefresh(!autoRefresh)}
                                />
                              </SoftBox>
                              <SoftBox>
                                <SoftTypography
                                  className="refresh-switch-label"
                                  variant="button"
                                  fontWeight="regular"
                                  style={{
                                    marginLeft: "5px",
                                    color: "#67748e",
                                  }}
                                >
                                  {autoRefresh ? "Auto" : "Manual"}
                                </SoftTypography>
                              </SoftBox>

                              <SoftBox>
                                <Button
                                  alt="Manually Refresh Data"
                                  disabled={autoRefresh || refreshPressed}
                                  onClick={(e) => handleRefreshData(e)}
                                  className={
                                    autoRefresh || refreshPressed ? "show-disable-pointer" : ""
                                  }
                                >
                                  <Icon>refresh</Icon>
                                </Button>
                              </SoftBox>
                            </SoftBox>
                          </SoftBox>
                        </SoftBox>
                        <SoftBox
                          style={{
                            width: "100%",
                            position: "absolute",
                            display: refreshPressed ? "" : "none",
                          }}
                        >
                          <SoftProgress variant="gradient" value={refreshPercentage} />
                          <SoftTypography sx={{ textAlign: "center", fontSize: "0.7rem" }}>
                            time left until next Available SportsBook Refresh
                          </SoftTypography>
                        </SoftBox>
                      </Card>

                      <SoftBox mt={2} className="page-scrolling-holder" onScroll={scrolling}>
                        <TableContainer id="fixtures-table-holder" onScroll={scrolling}>
                          <div id="topCompetitions" style={{ opacity: "hidden" }}></div>
                          <FixturesTable
                            selectedSport={sportSelected}
                            eventType={typeSelected}
                            filterSportData={filtersData}
                            autoRefresh={autoRefresh}
                            refresh={refresh}
                            communicateWithParent={handleActions}
                          ></FixturesTable>
                        </TableContainer>
                      </SoftBox>
                    </SoftBox>
                  </Card>
                </SoftBox>
              </Grid>
            </Grid>
          </SoftBox>
        </SoftBox>
      </SoftBox>

      <TemplatesApplier
        openTemplateApplier={openTemplateApplier}
        handleCloseConfigurator={handleCloseConfigurator}
        handleDataConfigurator={handleDataConfigurator}
      />
      <SoftBox className="float-button" style={{ display: floatButton ? "" : "none" }}>
        <Button onClick={scrollToTop}>
          <Icon className="float-button-icon" style={{ fontSize: 3 + "rem !important" }}>
            last_page_outlined_icon
          </Icon>
        </Button>
      </SoftBox>
    </DashboardLayout>
  );
}

// Typechecking props for the DataTable
Sportsbook.propTypes = {
  sportId: PropTypes.number,
  filterTemplateId: PropTypes.number,
};

export default Sportsbook;
